import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { appendDispatchLog } from '../other/dispatchLog';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { transferToDriverStripeAccount } from './stripeactions';
import { addActualsToBooking, saveAddresses, updateDriverQueue } from "../other/sharedFunctions";
import { get, onValue, update, off, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import {
  logFirstTripCompleted,
  logTripCompleted,
  checkIfFirstTrip,
} from "../other/facebookAnalytics";

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;

  off(bookingListRef(userInfo.uid, userInfo.usertype));
  onValue(bookingListRef(userInfo.uid, userInfo.usertype),(snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const active = [];
      let tracked = null;
      const bookings = Object.keys(data)
        .map((i) => {
          data[i].id = i;
          data[i].pickupAddress = data[i].pickup.add;
          data[i].dropAddress = data[i].drop.add;
          data[i].discount = data[i].discount
            ? data[i].discount
            : 0;
          data[i].cashPaymentAmount = data[i].cashPaymentAmount
            ? data[i].cashPaymentAmount
            : 0;
          data[i].cardPaymentAmount = data[i].cardPaymentAmount
            ? data[i].cardPaymentAmount
            : 0;
          return data[i];
        });
      for (let i = 0; i < bookings.length; i++) {
        if (['PAYMENT_PENDING','NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'AT_STOP', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
          active.push(bookings[i]);
        }
        if ((['ACCEPTED', 'ARRIVED', 'STARTED', 'AT_STOP'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
          tracked = bookings[i];
          fetchBookingLocations(tracked.id)(dispatch);
        }
      }
      dispatch({
        type: FETCH_BOOKINGS_SUCCESS,
        payload: {
          bookings: bookings.reverse(),
          active: active,
          tracked: tracked
        },
      });
      if (tracked) {
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: null
        });
      }
    } else {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_bookings,
      });
    }
  });
};

export const updateBooking = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
    userRatingsRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  const existingSnap = await get(singleBookingRef(booking.id));
  const existing = existingSnap.val() || {};

  // Rider may close the trip (COMPLETE) before the driver confirms payment.
  // Keep COMPLETE terminal: merge payment fields only, do not revert to PAID.
  if (existing.status === "COMPLETE" && booking.status === "PAID") {
    await update(singleBookingRef(booking.id), {
      customer_paid: booking.customer_paid,
      discount: booking.discount,
      usedWalletMoney: booking.usedWalletMoney,
      cardPaymentAmount: booking.cardPaymentAmount,
      cashPaymentAmount: booking.cashPaymentAmount,
      payableAmount: booking.payableAmount,
      payment_mode: booking.payment_mode,
      promo_applied: booking.promo_applied,
      promo_details: booking.promo_details,
    });
    if (
      booking.driver &&
      auth.currentUser?.uid === booking.driver &&
      (booking.prepaid ||
        booking.payment_mode === "cash" ||
        booking.payment_mode === "wallet")
    ) {
      await update(singleUserRef(booking.driver), { queue: false });
    }
    return;
  }

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  
  if (booking.status == 'PAYMENT_PENDING') {
    update(singleBookingRef(booking.id),booking);
  }
  if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
    update(singleBookingRef(booking.id), updateDriverQueue(booking));
  }
  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    update(singleBookingRef(booking.id),booking);
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_arrived ? store.getState().languagedata.defaultLanguage.driver_arrived : store.getState().languagedata.defaultLanguage.driver_near,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }
  
  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;
    update(singleBookingRef(booking.id),booking);

    const driverLocation = store.getState().gpsdata.location;
    
    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'STARTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
      }
   }

  if (booking.status == 'REACHED') {

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    let address = await saveAddresses(booking,driverLocation);

    let bookingObj = await addActualsToBooking(booking, address, driverLocation);
    update(singleBookingRef(booking.id),bookingObj);

    // Track trip completion for customer
    if (booking.customer && booking.customer !== auth.currentUser.uid) {
      try {
        const { bookingListRef } = firebase;
        const isFirstTrip = await checkIfFirstTrip(booking.customer, bookingListRef(booking.customer, 'customer'));
        
        if (isFirstTrip) {
          logFirstTripCompleted(bookingObj);
        } else {
          // Count completed trips for trip_number (bookingListRef already has orderByChild; filter by status in client)
          const completedSnapshot = await get(bookingListRef(booking.customer, 'customer'));
          let tripNumber = 1;
          if (completedSnapshot.exists()) {
            const allBookings = completedSnapshot.val();
            const completedStatuses = ['COMPLETE', 'PAID', 'REACHED'];
            tripNumber = Object.values(allBookings).filter(b => 
              completedStatuses.includes(b.status)
            ).length;
          }
          logTripCompleted(bookingObj, tripNumber);
        }
      } catch (error) {
        if (__DEV__) {
          console.error('Error tracking trip completion:', error);
        }
      }
    }

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }

  if (booking.status == 'PENDING') {
    update(singleBookingRef(booking.id),booking);
    update(singleUserRef(booking.driver), { queue: false });
  }
  if (booking.status == 'PAID') {
    if(booking.booking_from_web){
      booking.status = 'COMPLETE';
    }
    update(singleBookingRef(booking.id), booking);
    if(booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')){
      update(singleUserRef(booking.driver), { queue: false });
    }

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
    }

  if (booking.status == 'COMPLETE') {
    update(singleBookingRef(booking.id), booking);
    
    // Track trip completion for customer when status is COMPLETE
    if (booking.customer && booking.customer !== auth.currentUser.uid) {
      try {
        const { bookingListRef } = firebase;
        const isFirstTrip = await checkIfFirstTrip(booking.customer, bookingListRef(booking.customer, 'customer'));
        
        if (isFirstTrip) {
          logFirstTripCompleted(booking);
        } else {
          // Count completed trips for trip_number (bookingListRef already has orderByChild; filter by status in client)
          const completedSnapshot = await get(bookingListRef(booking.customer, 'customer'));
          let tripNumber = 1;
          if (completedSnapshot.exists()) {
            const allBookings = completedSnapshot.val();
            const completedStatuses = ['COMPLETE', 'PAID', 'REACHED'];
            tripNumber = Object.values(allBookings).filter(b => 
              completedStatuses.includes(b.status)
            ).length;
          }
          logTripCompleted(booking, tripNumber);
        }
      } catch (error) {
        if (__DEV__) {
          console.error('Error tracking trip completion:', error);
        }
      }
    }
    
    if (booking.rating) {
      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.rating.toString()),
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
      onValue(userRatingsRef(booking.driver), snapshot => {
        let ratings = snapshot.val();
        let rating;
        if(ratings){
          let sum = 0;
          const arr = Object.values(ratings);
          for (let i = 0; i< arr.length ; i++){
            sum = sum + arr[i].rate
          }
          sum = sum + booking.rating;
          rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
        }else{
          rating =  booking.rating;
        }
        update(singleUserRef(booking.driver),{rating: rating});
        push(userRatingsRef(booking.driver), {
          user: booking.customer,
          rate: booking.rating,
          bookingId: booking.id
        });
      }, { onlyOnce: true});
    }
  }
};

export const cancelBooking = (data) => (dispatch) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  update(singleBookingRef(data.booking.id),{
    status: 'CANCELLED',
    reason: data.reason,
    cancelledBy: data.cancelledBy
  }).then(() => {
    if (data.booking.driver && (data.booking.status === 'NEW' || data.booking.status === 'ACCEPTED' || data.booking.status === 'ARRIVED' || data.booking.status === 'STARTED' || data.booking.status === 'PENDING')) {
      update(singleUserRef(data.booking.driver),{ queue: false });
      if(data.booking.driver_token){
        RequestPushMsg(
          data.booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
              screen: 'BookedCab',
              params: { bookingId: data.booking.id }
          });
        }

        if(data.booking.customer_token){
          RequestPushMsg(
            data.booking.customer_token,
            {
                title: store.getState().languagedata.defaultLanguage.notification_title,
                msg:  store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
                screen: 'BookedCab',
                params: { bookingId: data.booking.id }
            });
        }
   }
    if (data.booking.status === 'NEW') {
      const requestedSnapshot = data.booking.requestedDrivers || {};
      const preRequestedSnapshot = data.booking.preRequestedDrivers || {};
      appendDispatchLog(data.booking.id, {
        event: 'dispatch_cleared',
        source: 'cancelBooking',
        previousStatus: data.booking.status,
        cancelledBy: data.cancelledBy,
        reason: data.reason || null,
        requestedDriverUids: Object.keys(requestedSnapshot),
        preRequestedDriverUids: Object.keys(preRequestedSnapshot),
        note: 'requestedDrivers node removed from booking; dispatchLog preserved',
      }).catch((err) => console.warn('dispatchLog:', err));
      remove(requestedDriversRef(data.booking.id));
    }
  });
};

export const arriveAtStop = (booking) => async (dispatch) => {
  const { singleBookingRef } = firebase;
  const idx = booking.currentStopIndex ?? 0;
  const now = new Date().getTime();
  const updates = {
    status: "AT_STOP",
    [`stops/${idx}/status`]: "ARRIVED",
    [`stops/${idx}/arrived_at`]: now,
    [`stops/${idx}/timer_start`]: now,
  };
  await update(singleBookingRef(booking.id), updates);

  const stops = [...(booking.stops || [])];
  if (stops[idx]) {
    stops[idx] = {
      ...stops[idx],
      status: "ARRIVED",
      arrived_at: now,
      timer_start: now,
    };
  }
  const updatedBooking = { ...booking, status: "AT_STOP", stops };
  dispatch({ type: UPDATE_BOOKING, payload: updatedBooking });

  if (booking.customer_token) {
    const lang = store.getState().languagedata.defaultLanguage;
    const settings = store.getState().settingsdata.settings;
    const stopNum = idx + 1;
    const totalStops = stops.length;
    const waitSec =
      parseInt(booking.stopover_wait_seconds, 10) ||
      parseInt(settings?.stopover_wait_seconds, 10) ||
      180;
    const durationLabel =
      waitSec >= 60
        ? `${Math.ceil(waitSec / 60)} ${lang.min || "min"}`
        : `${waitSec}s`;
    let msg = lang.stopover_arrival_push;
    if (msg) {
      msg = msg
        .replace("%{n}", String(stopNum))
        .replace("%{m}", String(totalStops))
        .replace("%{duration}", durationLabel);
    } else if (lang.driver_at_stop_n_of_m) {
      msg = lang.driver_at_stop_n_of_m
        .replace("%{n}", String(stopNum))
        .replace("%{m}", String(totalStops));
    } else {
      msg = `Driver arrived at stop ${stopNum} of ${totalStops}. You have ${durationLabel} to return.`;
    }
    RequestPushMsg(booking.customer_token, {
      title: lang.stopover_arrival_title || lang.notification_title,
      msg,
      screen: "BookedCab",
      params: { bookingId: booking.id },
      sound: "default",
    });
  }
};

export const resumeFromStop = (booking) => async (dispatch) => {
  const { singleBookingRef } = firebase;
  const idx = booking.currentStopIndex ?? 0;
  const now = new Date().getTime();
  const nextIdx = idx + 1;
  const updates = {
    status: "STARTED",
    currentStopIndex: nextIdx,
    [`stops/${idx}/status`]: "COMPLETED",
    [`stops/${idx}/departed_at`]: now,
  };
  await update(singleBookingRef(booking.id), updates);

  const stops = [...(booking.stops || [])];
  if (stops[idx]) {
    stops[idx] = {
      ...stops[idx],
      status: "COMPLETED",
      departed_at: now,
    };
  }
  const updatedBooking = {
    ...booking,
    status: "STARTED",
    currentStopIndex: nextIdx,
    stops,
  };
  dispatch({ type: UPDATE_BOOKING, payload: updatedBooking });

  if (booking.customer_token) {
    const lang = store.getState().languagedata.defaultLanguage;
    const stopsRemaining = stops.slice(nextIdx);
    const nextLabel =
      stopsRemaining.length > 0
        ? stopsRemaining[0].add || lang.next_stop || "next stop"
        : booking.drop?.add || lang.final_destination || "final destination";
    RequestPushMsg(booking.customer_token, {
      title: lang.trip_resumed_title || lang.notification_title,
      msg: lang.trip_resumed_towards
        ? lang.trip_resumed_towards.replace("{destination}", nextLabel)
        : `Trip continues towards ${nextLabel}`,
      screen: "BookedCab",
      params: { bookingId: booking.id },
    });
  }
};

export const cancelBookingByDriverTimeout = (booking) => async (dispatch) => {
  const { singleBookingRef, singleUserRef } = firebase;
  const now = new Date().getTime();
  await update(singleBookingRef(booking.id), {
    status: "CANCELLED",
    cancelledBy: "driver",
    reason: "stopover_timeout",
    cancelledAt: now,
  });

  if (booking.driver) {
    await update(singleUserRef(booking.driver), { queue: false });
  }

  dispatch({
    type: UPDATE_BOOKING,
    payload: {
      ...booking,
      status: "CANCELLED",
      cancelledBy: "driver",
      reason: "stopover_timeout",
      cancelledAt: now,
    },
  });
};

export const updateBookingImage = (booking, imageType, imageBlob) => (dispatch) => {
  const   {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  uploadBytesResumable(bookingImageRef(booking.id,imageType), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(bookingImageRef(booking.id,imageType))
  }).then((url) => {
    if(imageType == 'pickup_image'){
      booking.pickup_image = url;
    }
    if(imageType == 'deliver_image'){
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
    bookingListRef,
    auth,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });
  
  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    update(singleUserRef(booking.driver),{ queue: false });

    if(booking.prepaid){

      const settingsdata = await get(settingsRef);
      const settings = settingsdata.val();

      const pm = (booking.payment_mode || '').toLowerCase();
      const needStripeTransfer = pm === 'wallet' || pm === 'card';

      if (needStripeTransfer) {
        try {
          await dispatch(transferToDriverStripeAccount({ bookingId: booking.id }));
        } catch (err) {
          if (__DEV__) {
            console.error('forceEndBooking transferToDriverStripeAccount error:', err);
          }
        }
      } else {
        onValue(singleUserRef(booking.driver), snapshot => {
          let walletBalance = parseFloat(snapshot.val().walletBalance);
          walletBalance = walletBalance + parseFloat(booking.driver_share);
          if(parseFloat(booking.cashPaymentAmount)>0){
            walletBalance = walletBalance - parseFloat(booking.cashPaymentAmount);
          }
          update(singleUserRef(booking.driver),{"walletBalance": parseFloat(walletBalance.toFixed(settings.decimal))});

          let details = {
            type: 'Credit',
            amount: parseFloat(booking.driver_share).toFixed(settings.decimal),
            serviceFee: parseFloat(
              parseFloat(booking.convenience_fees || 0).toFixed(settings.decimal)
            ),
            date: new Date().getTime(),
            txRef: booking.id
          }
          push(walletHistoryRef(booking.driver),details);
          
          if(parseFloat(booking.cashPaymentAmount)>0){
            let details = {
              type: 'Debit',
              amount: booking.cashPaymentAmount,
              date: new Date().getTime(),
              txRef: booking.id
            }
            push(walletHistoryRef(booking.driver), details);
          }
        },{onlyOnce: true});
      }

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }

      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
        }
      booking.status = 'PAID';
    } else{
      booking.status = 'PENDING';
    }

    // Track trip completion for customer when force ending booking
    if (booking.customer && booking.customer !== auth.currentUser.uid) {
      try {
        const isFirstTrip = await checkIfFirstTrip(booking.customer, bookingListRef(booking.customer, 'customer'));
        
        if (isFirstTrip) {
          logFirstTripCompleted(booking);
        } else {
          // Count completed trips for trip_number (bookingListRef already has orderByChild; filter by status in client)
          const completedSnapshot = await get(bookingListRef(booking.customer, 'customer'));
          let tripNumber = 1;
          if (completedSnapshot.exists()) {
            const allBookings = completedSnapshot.val();
            const completedStatuses = ['COMPLETE', 'PAID', 'REACHED', 'PENDING'];
            tripNumber = Object.values(allBookings).filter(b => 
              completedStatuses.includes(b.status) && b.id !== booking.id
            ).length + 1;
          }
          logTripCompleted(booking, tripNumber);
        }
      } catch (error) {
        if (__DEV__) {
          console.error('Error tracking trip completion in forceEndBooking:', error);
        }
      }
    }

    update(singleBookingRef(booking.id), booking);
  }
};